<template>
	<div class="focusenterprises" >
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage targetenterlist">
				<div class="whitebox right_topbox targetenterlist-title">
					<div class="w95mg"> 
						<h5 class="title1 fl">{{specialPagename}}</h5>
						<span class="notionname fl">{{notionname}}</span>
						<h5 class="title fl" @mouseover="mapcityBtn=false;citylistbtn=true" v-if="selectcitydata.length>0">城市选择</h5> 
						<h5 class="title fl" @mouseover="mapcityBtn=true;citylistbtn=false" v-if="citymapdata.length>0">{{keywords}}地图</h5>
					</div>
				</div> 
				<!-- 企业列表 -->
				<div class="usermg usercl_box whitebox">
					<div class="enterparise_guide oh w95mg sp">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>   
					</div>
					<ul class="user_tabtitle w95mg" >
						<li v-for="(item,i) in tabtitle" :key="i" :class="type==item.type?'current':''"	@click="tabbtnfun(item,i)">{{item.name}}</li>
						<!-- <li :class="tabbtn==10?'current':''" @click="tabbtn = 10;getcollectlist(tabbtn)">优质企业</li> -->
					</ul>
					<!-- 龙头  优质 上市 创新通用表格 -->
					<div class="collect_bigEns w95mg">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>企业名称</th>
								<th>地区</th>
								<th  v-for="(list,index) in dimesmlist" :key="index">
									<div @click="tablesort(list.type);"  :style="'width:'+list.name.length*16+'px'" :class="{'td_sortname ':true,'current':orderField == list.type}" >
											<span		:class="{'sortname ':true,'current':orderField == list.type,'fz15':list.name.length>5}">{{list.name}}</span><span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
									</div> 
								</th>
								<!-- <th>行业机会</th>
								<th>政策力度</th> -->
								<th>拿地数量</th>
								<th>拿地面积</th>
								<th>投资项目数量</th>
								<th>投资项目金额</th> 
								<th>编辑</th> 
							</tr>
							<tr>
							<tr v-for="list in entercommlist">
								 <td ><span  class="title"		@click="routerlinkid('/enterprises',list.stockCode,list.title)">{{list.title}}</span></td>
								 <td>{{list.area}}</td>
								 <td>{{list.zs000000}}</td>
								 <td>{{list.zs100000}}</td>
								 <td>{{list.zs200000}}</td> 
								 <!-- <td>{{list.zs300000}}</td> 
								 <td>{{list.zs500000}}</td> -->
								 <td>{{list.landCount}}</td>
								 <td>{{list.landSize}}{{list.landSize>0?list.landSizeUnit:''}}</td>
								 <td>{{list.investCount}}</td>
								 <td>{{list.investMoney}}{{list.investMoney>0?list.investMoneyUnit:''}}</td>
								 <td class="collectfont1"><span  @click="collectToggle(list)">{{list.collectId == 0?'加入':'移除'}}目标企业</span></td>
							</tr>
						</table>
					</div> 
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
				<!-- 城市列表 -->
				<div class="notion_slide1" v-show="citylistbtn" v-if="selectcitydata.length>0">
					<h5  @click="choosecityid(0,1);" :class="cityid == 0?'current title1':'title1'">全国城市<em>({{total}})</em></h5>
					<div class="notion_li1" v-for="(list,index) in selectcitydata" v-if="index<10">
						<h5  @click="choosecityid(list.id,1,list.name);" :class="list.id == provinceid?'current title':'title'">{{list.name}}<em>({{list.count}})</em></h5>
						<div class="fl"><span  v-for="item in list.children" @click="choosecityid(item.id,2,item.name);" :class="item.id == cityid?'current':''">{{item.name}}<em>({{item.count}})</em></span></div>
					</div>
					<div class="morecitydata" v-if="selectcitydata.length>10" v-show="showmorecitydata"> 
						<div class="notion_li1" v-for="(list,index) in selectcitydata" v-if="index>9">
							<h5  @click="choosecityid(list.id,1,list.name)" :class="list.id == provinceid?'current title':'title'">{{list.name}}<em>({{list.count}})</em></h5>
							<div class="fl"><span  v-for="item in list.children" @click="choosecityid(item.id,2,item.name);" :class="item.id == cityid?'current':''">{{item.name}}<em>({{item.count}})</em></span></div>
						</div> 
					</div>
					<div class="showmorecity" v-text="showmorecitydata?'隐藏更多城市':'展开显示更多'" @click="showmorecitydata=!showmorecitydata"></div>
					<div class="fr listclose_btn" @click="citylistbtn=false;">关闭</div>
				</div>
				<!-- 城市地图 -->
				<div class="notion_slide3" v-show="mapcityBtn">
					<div class="citymapblock por">
						<chainMap :mapdata="citymapdata" v-if="citymapdata.length>0" :citymapflag="true" v-on:chartmapclick="chartmapclick"  ></chainMap>
						<div class="listclose_btn" @click="mapcityBtn=false">关闭</div>
					</div>
				</div>
				<!--  -->
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'mapserch',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				title:"目标招商企业",total1:1,notionlist:[],curWebsite:this.$api.getWebsiteType(), 
				specialPagename:"",keywords:'招商',
				userdata: {},pagetype:1,notioncode:0,notionname:'',tabindex:0,type:0,tabtogglebtn:true,choosecity:false,
				selectcitydata:[], citymapdata:[], cityflag:false,citylistbtn:false,showmorecitydata:false, 
				cityid:0,provinceid:0,mapcityBtn:false,choosecitydata:[],
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序 
				tabtitle: [
					{curindex: 1,type: 9,name: "上市公司",tabindex:0,},
					{curindex: 2,type: 1,name: "龙头企业",tabindex:1,},
					{curindex: 3,type: 2,name: "创新企业",tabindex:2}, 
					{curindex: 4,type: 3,name: "优质企业",tabindex:3},  
					{curindex: 5,type: 0,name: "全部内资企业",tabindex:4},  
				],  
				dimesmlist:[{name: '总体评分',type: 0}, {name: '企业实力',type: 2	}, {name: '投资力度',type: 3},],
				// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},{name:'营业收入（亿元）',type:12},{name:'营收增速',type:13},{name:'净利润（亿元）',type:14},{name:'净利增速',type:15},
				tabbtn: 1, 
				entercommlist:[],   
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
			}
		},
		created() {
			this.notionname=this.$route.query.keyword; 
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
		},
		mounted() {  
			this.specialPagename='相关企业推荐';
			if(this.curWebsite.type == 2){
				this.keywords="产业";
			}else if(this.curWebsite.type == 4){
				this.keywords="信贷";
			}
			this.userdata = this.getuseriformation();
			this.notioncode=this.$route.query.id;
			this.type=this.$route.query.type?this.$route.query.type:0; 
			document.title=this.specialPagename+'-'+this.curWebsite.name;
			this.bus.$emit('loading', true); 
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
			this.getlist();
			
			// this.getcollectlist(2);
			// this.getcollectlist(3);
			// this.getcollectlist(4);
		},
		methods: { 
			//地图点击事件
			choosecityide(art){
				// console.log(art); 
				this.choosecityid(art[0],art[1]);
			},
			chartmapclick(data){ 
				var type="";
				if(data.data!=undefined && data.data.length>0){ 
					type=1;
				};
				this.choosecityid(data.id,type);
				this.mapcityBtn=false;
				// console.log('选中的地图数据',data);
				this.choosecitydata = data;  
			}, 
			//选择城市
			choosecityid(id,type){ 
				if(type == 1){
					this.provinceid=id;
					this.cityid=0;
				}else{
					this.provinceid=0;
					this.cityid=id;
				}  
				this.getlist(); 
			}, 
			//tab栏切换
			tabbtnfun(list,index){
				this.page=1;
				if(this.type!=list.type){
					this.tabtogglebtn=true;this.provinceid=0;this.cityid=0;
					this.type=list.type;
					this.getlist();
				} 
			},
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getlist();
				// this.ajaxsearchcompany();
			},
			pageHandler: function(page) {
				this.page = page;
				this.getlist();
			},
			//获取产业链收藏列表
			getlist() {
				// this.bus.$emit('loading',true);
				var _this = this; 
				var provinceidja =this.splicing('province',this.provinceid);
				var cityidja =this.splicing('city',this.cityid); 
				var ajaxurl = this.$api.cyl.enterprise.list() + '?calCity=1&resultType=1&param=1&search=0&type=' + this.type + '&page='+this.page+'&orderField='+this.orderField+'&orderType='+this.orderType+'&notion='+this.notioncode+provinceidja+cityidja;
				this.$axios.get(ajaxurl, {
					headers: {AuthToken: this.userdata.token}
				}).then(function(res) {
					console.log(ajaxurl);
					console.log(res.data)
					if (res.data.success) {
						var enterlist = res.data.list;  
						_this.entercommlist=enterlist;
						
						//导航栏城市地图筛选
						// _this.cityscreen(res.data.cityList);
						if(_this.tabtogglebtn){
							var citylistd=[],citytest=res.data.cityList;
							for(var i=0;i<citytest.length;i++){
								let citylista ={}; 
								citylista.value=citytest[i].count;  
								citylista.id=citytest[i].id;  
								citylista.name=_this.citynameremove(citytest[i].name); 
								citylista.data=[];
								for(var p=0;p<citytest[i].children.length;p++){
									let citydtac={};
									citydtac.value=citytest[i].children[p].count;
									citydtac.id=citytest[i].children[p].id;
									citydtac.name=citytest[i].children[p].name;
									citylista.data.push(citydtac); 
								}
								citylistd.push(citylista); 
							};   
							_this.selectcitydata=citytest;
							_this.citymapdata=citylistd;
							_this.cityflag=true; 
							_this.tabtogglebtn=false;
							// _this.total1=res.data.totalRecord;
						}
						
						//分页数据
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize; 
						_this.bus.$emit('loading',false); 
					} else {
						
					}
				}).catch(function(error) {
					// console.log('错误',error);//请求失败处理 
				}); 
			},
			//加入、移除目标企业
			collectToggle(list){
				var _this=this,cid=list.collectId;
				var ajaxurl="",ajaxdata={};
				if(cid == 0){
				 ajaxurl=this.$api.cyl.collect.add();
					ajaxdata={type:list.collectType,id:list.stockCode}
					}else{
						ajaxurl=this.$api.cyl.collect.remove();
						ajaxdata={collectId:list.collectId};
					}
					$.ajax({
						type:"POST",
						url:ajaxurl,
						data:ajaxdata,
						headers:{AuthToken:this.userdata.token },
						success:function(res){ 
							// console.log('1123',res);
							if(res.success){
								if(cid == 0){
									list.collectId=res.data.collectId;
								}else{
									list.collectId=0;
								} 
							} 
						} 
					}) 
			}
		 
		},
	}
</script> 
